export const formatPrice = (n) => '$' + Math.round(n).toLocaleString('es-CO');
